import { Dayjs } from 'dayjs'
import { isNil, map, omitBy } from 'lodash'
import { IWithdrawalsHistoryFilterValues } from '../../pages/withdrawals/dashboard/WithdrawalsDashboardHistory'
import { Paths } from '../../types/api'
import { USERS_CONTRACT_STATUS, WITHDRAWAL_STATE } from '../../utils/enums'
import { setDate, setWithdrawalState } from '../../utils/helpers'
import { IWithdrawalsLoadListByUserPayload } from './withdrawalsActions'

export const mapWithdrawalsLoadListByUserRequest = (
	filter: IWithdrawalsHistoryFilterValues & { exceptWithdrawalIDS?: string[] }
): Paths.GetApiV1UsersUserIdWithdrawals.QueryParameters => {
	const { page, limit, exceptWithdrawalIDS } = filter

	return omitBy(
		{
			page: page,
			limit: limit,
			exceptWithdrawalIDS: exceptWithdrawalIDS
		},
		isNil
	) as Paths.GetApiV1UsersUserIdWithdrawals.QueryParameters
}

export const mapWithdrawalsLoadListByUserResponse = (
	payload: Paths.GetApiV1UsersUserIdWithdrawals.Responses.$200
): Omit<IWithdrawalsLoadListByUserPayload, 'isLoading' | 'isFailure'> => {
	const { withdrawals, pagination } = payload
	return {
		records: map(
			withdrawals,
			({
				withdrawalID,
				createdAt,
				updatedAt,
				amount,
				status,
				autoApproved,
				autoapprovalRejectionReason,
				currency,
				owner: {
					userID,
					firstName,
					lastName,
					company: { companyID, name },
					contractStatus
				}
			}) => ({
				id: withdrawalID,
				createdDate: setDate(createdAt) as Dayjs,
				updatedDate: setDate(updatedAt) as Dayjs,
				amount: amount,
				state: setWithdrawalState(status) as WITHDRAWAL_STATE,
				autoApproved: autoApproved,
				autoapprovalRejectionReason: autoapprovalRejectionReason,
				currency: currency,
				employee: {
					id: userID,
					firstName: firstName,
					lastName: lastName,
					company: {
						id: companyID,
						name: name
					},
					contractStatus: contractStatus as USERS_CONTRACT_STATUS
				}
			})
		),
		pagination: pagination
	}
}
